export const GoogleCloudGeocodingApiKey = 'AIzaSyAl4rXfKqh_tX22wQqG3gufbbCsnsnfxoo';
export const GoogleCloudGeolocationApiKey = 'AIzaSyBONcM1FkI6CzaDO3iYuSfqhgIMuoAUTnE';
export const SITE_ORIGIN_LOCAL_STORAGE_KEY = 'eet-site-origin';
